export default "__VITE_ASSET__BdQnXhmB__"